import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { entries, keys, values } from 'lodash';
import {
  Badge,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
} from '@chakra-ui/react';

import { addData, deleteData, updateData } from '../../../api/tabsApi';
import useForm, { TField } from '../../form/Form';
import SubTabs from '../../tabs/SubTabs';
import { TState, useActions } from '../../../redux/store';
import {
  useAllTabs,
  useCanI,
  useGetSelect,
  useSubTabs,
} from '../../../redux/actions';
import { isEmpty } from '../../../helpers';
import Modal from '../../modal/Modal';
import FileTab from '../../files/FileTab';
import { addressInputskeys } from './ManageInputs';

const ZONES: any = {
  '01': 'H1',
  '02': 'H1',
  '03': 'H1',
  '04': 'H2',
  '05': 'H1',
  '06': 'H3',
  '07': 'H2',
  '08': 'H1',
  '09': 'H2',
  '10': 'H1',
  '11': 'H3',
  '12': 'H2',
  '13': 'H3',
  '14': 'H1',
  '15': 'H1',
  '16': 'H2',
  '17': 'H2',
  '18': 'H2',
  '19': 'H1',
  '21': 'H1',
  '22': 'H2',
  '23': 'H1',
  '24': 'H2',
  '25': 'H1',
  '26': 'H2',
  '27': 'H1',
  '28': 'H1',
  '29': 'H2',
  '2A': 'H3',
  '2B': 'H3',
  '30': 'H3',
  '31': 'H2',
  '32': 'H2',
  '33': 'H2',
  '34': 'H3',
  '35': 'H2',
  '36': 'H2',
  '37': 'H2',
  '38': 'H1',
  '39': 'H1',
  '40': 'H2',
  '41': 'H2',
  '42': 'H1',
  '43': 'H1',
  '44': 'H2',
  '45': 'H1',
  '46': 'H2',
  '47': 'H2',
  '48': 'H2',
  '49': 'H2',
  '50': 'H2',
  '51': 'H1',
  '52': 'H1',
  '53': 'H2',
  '54': 'H1',
  '55': 'H1',
  '56': 'H2',
  '57': 'H1',
  '58': 'H1',
  '59': 'H1',
  '60': 'H1',
  '61': 'H1',
  '62': 'H1',
  '63': 'H1',
  '64': 'H2',
  '65': 'H2',
  '66': 'H3',
  '67': 'H1',
  '68': 'H1',
  '69': 'H1',
  '70': 'H1',
  '71': 'H1',
  '72': 'H2',
  '73': 'H1',
  '74': 'H1',
  '75': 'H1',
  '76': 'H1',
  '77': 'H1',
  '78': 'H1',
  '79': 'H2',
  '80': 'H1',
  '81': 'H2',
  '82': 'H2',
  '83': 'H3',
  '84': 'H2',
  '85': 'H2',
  '86': 'H2',
  '87': 'H1',
  '88': 'H1',
  '89': 'H1',
  '90': 'H1',
  '91': 'H1',
  '92': 'H1',
  '93': 'H1',
  '94': 'H1',
  '95': 'H1',
  '97': 'H3',
};

// const COLORS: any = {
//   tres_modeste: { title: 'BLEU', color: 'blue.500' },
//   modeste: { title: 'JAUNE', color: 'yellow.500' },
//   intermediaire: { title: 'VIOLET', color: 'purple.500' },
//   supérieure: { title: 'ROSE', color: 'pink.500' },
// };

const ManageEntries = () => {
  const theme = useSelector((state: TState) => state.theme);
  const rowData = useSelector((state: TState) => state.rowData);
  const currentTab = useSelector((state: TState) => state.currentTab);
  const modalType = useSelector((state: TState) => state.modalType);
  const isAdmin = useSelector((state: TState) => state.isAdmin);
  const modalData = useSelector((state: TState) => state.modalData);
  const isMobile = useSelector((state: TState) => state.isMobile);
  const allTabs = useAllTabs();
  const getInput = useGetSelect();

  const {
    setModalType,
    onClose,
    fetchAppointments,
    getData,
    setRowData,
    setModalData,
    getDataDetail,
    setPlanningAddress,
  } = useActions();

  const subTabs = useSubTabs();
  const canI = useCanI();
  const toast = useToast();

  const postal = entries(rowData).find(([k]) => /_postal$/.test(k))?.[1] || '';
  const dept = postal?.slice(0, 2);

  const zone = dept && ZONES[dept];

  // const [color, setColor] = useState<{ title: string; color: string }>();

  useEffect(() => {
    if (modalType === 'editEntry') {
      getDataDetail({ rowId: rowData._id });
    }

    setPlanningAddress('');
  }, []);

  useEffect(() => {
    setModalData((md: any) => ({ ...md, original: rowData }));
  }, [rowData]);

  useEffect(() => {
    // const fetchStatus = async () => {
    //   const postalINSEE = await axios.get(
    //     `https://api-adresse.data.gouv.fr/search/?q=${postal}`,
    //   );
    //   const resp = await axios.post(
    //     'https://mesaidesreno.beta.gouv.fr/api/v1?fields=m%C3%A9nage.revenu.classe',
    //     {
    //       'vous . propriétaire . statut': 'propriétaire',
    //       'logement . propriétaire occupant': 'oui',
    //       'logement . commune': `'${postalINSEE.data.features[0].properties.citycode}'`,
    //       'ménage . personnes': 2,
    //       'ménage . revenu': 50002,
    //     },
    //   );
    //   setColor(COLORS[resp.data['ménage.revenu.classe'].rawValue]);
    // };
    // fetchStatus();
  }, [postal]);

  const isExternal = modalData?.isExternal;

  const advancedInputs = (
    isExternal ? currentTab?.childs || [] : subTabs
  ).reduce((prev: TField[], tab) => {
    if (!tab.parent_id || tab.isMenu) return prev;

    return [
      ...prev,
      ...tab.tableColumns.flatMap((adCol, idx) =>
        adCol.tableColumns.map((col) => ({
          ...col,
          showTime: getInput(col.name_id || '')?.showTime ?? col.showTime,
          parent_id: tab._id,
          container_id: idx,
          type: col.type === 'text' ? '' : col.type,
          noFormat: true,
        })),
      ),
    ];
  }, []);

  const isAdd = modalType === 'addEntry';
  const isPlanning = currentTab?.isPlanning;

  const updateModalData = (bool: boolean) => {
    setModalData((md: any) => ({ ...md, hasUpdates: bool }));
  };

  const { Form, handleSubmit, pending, formData, setErrors, errors } = useForm(
    advancedInputs,
    {
      onSubmit: isAdd ? addData : updateData,
      planable: modalType !== 'addEntry' && currentTab?.planable,
      direction: 'column',
      onChange: () => {
        updateModalData(true);
      },
    },
  );

  const checkRole = useCallback(
    (name_id: string) =>
      canI(name_id, isAdd ? 'create' : ['read', 'update']) ||
      canI(`${name_id}_street`, isAdd ? 'create' : ['read', 'update']) ||
      canI(`${name_id}_city`, isAdd ? 'create' : ['read', 'update']) ||
      canI(`${name_id}_postal`, isAdd ? 'create' : ['read', 'update']) ||
      canI(`${name_id}_dept`, isAdd ? 'create' : ['read', 'update']),
    [isAdd],
  );

  const handleEntry = async () => {
    if (!values(formData).filter((v) => !isEmpty(v)).length) {
      toast({
        title: 'Dossier vide',
        status: 'error',
        isClosable: true,
      });

      return;
    }

    setErrors({});

    const errs = advancedInputs.reduce(
      (prev, input: TField) => {
        const isRepeat = input.type === 'repeatgroup';

        if (isRepeat) {
          const repeatErrors = { ...prev };
          formData[`${input.name_id}`] &&
            Array(Number(formData[`${input.name_id}`]))
              .fill('')
              .forEach((_, idx) =>
                input.repeatFields?.forEach((name) => {
                  if (
                    getInput(name)?.required &&
                    checkRole(name) &&
                    isEmpty(formData[`repeat_${name}_${idx}`])
                  ) {
                    repeatErrors[`repeat_${name}_${idx}`] = {
                      tabId: input.parent_id,
                    };
                  }
                }),
              );

          return repeatErrors;
        }

        const hasAddressValue =
          input.type === 'address' &&
          addressInputskeys.some((k) => formData[`${input.name_id}_${k}`]);

        return input.name_id &&
          input.required &&
          isEmpty(formData[`${input.name_id}`]) &&
          !hasAddressValue &&
          checkRole(input.name_id)
          ? { ...prev, [input.name_id]: { tabId: input.parent_id } }
          : prev;
      },
      {} as Record<string, { tabId?: string }>,
    );

    setErrors(errs);

    if (keys(errs).length) {
      toast({
        title: 'Certains champs obligatoires n’ont pas été renseignés',
        status: 'error',
      });
      return;
    }

    const resp = await handleSubmit();

    updateModalData(false);

    if (resp.isDuplicate) {
      return;
    }

    getData({ noRefresh: true });

    if (!isAdd && isPlanning) {
      fetchAppointments();
      return;
    }

    setModalType('editEntry');
    setRowData(resp.data);
  };

  const handleDeleteEntry = async () => {
    await deleteData(rowData._id);
    getData({ noRefresh: true });
    onClose();
  };

  const renderManageEntries = isExternal ? (
    <Tabs>
      <TabList justifyContent='center'>
        <Tab>FORMULAIRE</Tab>
        <Tab>DOCUMENTS</Tab>
      </TabList>

      <TabPanels>
        <TabPanel p={0} pt={3}>
          {Form}
        </TabPanel>
        <TabPanel p={0} pt={3}>
          <FileTab />
        </TabPanel>
      </TabPanels>
    </Tabs>
  ) : (
    <SubTabs forms={Form} errs={errors} />
  );

  const updatePermission =
    isExternal ||
    (currentTab?._id && canI(currentTab?._id, 'update')) ||
    (isPlanning && canI('planning', 'update'));
  const deletePermission = !isExternal && isAdmin; //currentTab?._id && canI(currentTab?._id, 'delete');

  const renderDeleteEntry = <Text>Confirmer la suppression ?</Text>;
  const currentPage = `${
    currentTab?.parent_id ? `${allTabs[currentTab?.parent_id]?.title} / ` : ''
  }${currentTab?.title}`;

  const hint = (
    <Flex alignItems='center' direction={'column'} mt={1}>
      <Flex justifyContent='left' w='100%'>
        <Text color='red' mx={1}>
          *
        </Text>
        <Text fontStyle='italic' fontSize={theme.fontSize.xSmall}>
          {'Champs obligatoires'}
        </Text>
      </Flex>
      <Flex justifyContent='left' w='100%'>
        <Text color='orange.400' mx={1}>
          *
        </Text>
        <Text fontStyle='italic' fontSize={theme.fontSize.xSmall}>
          {isMobile
            ? 'Champs importants'
            : 'Champs importants pour la complétion du dossier'}
        </Text>
      </Flex>
    </Flex>
  );

  const modalOptions = {
    addEntry: {
      component: renderManageEntries,
      action: handleEntry,
      title: 'Ajouter client',
      actionLabel: 'Ajouter',
      hint,
    },
    editEntry: {
      component: renderManageEntries,
      canDelete: deletePermission ? 'deleteEntry' : '',
      action: updatePermission && handleEntry,
      pending,
      title: isExternal ? (
        ''
      ) : (
        <>
          {`${currentPage} / Edition`}
          {zone && (
            <Badge
              ml={3}
              fontSize={theme.fontSize.normal}
              bg={theme.dark}
              color={theme.none}
              borderRadius={5}
            >
              {zone}
            </Badge>
          )}
          {/* {color && (
            <Badge
              ml={3}
              fontSize={theme.fontSize.normal}
              bg={color.color}
              color={theme.none}
              borderRadius={5}
            >
              {color.title}
            </Badge>
          )} */}
        </>
      ),
      actionLabel: 'Sauvegarder',
      hint,
      // url: !isExternal && true,
      planning: !isExternal && true,
    },
    deleteEntry: {
      component: renderDeleteEntry,
      action: handleDeleteEntry,
      title: 'Supprimer client',
      actionLabel: 'Confirmer',
    },
  };

  return <Modal options={modalOptions} />;
};

export default ManageEntries;
